import { render } from "./ImagenProducto.vue?vue&type=template&id=dcc717b8&scoped=true"
import script from "./ImagenProducto.vue?vue&type=script&lang=js"
export * from "./ImagenProducto.vue?vue&type=script&lang=js"

import "./ImagenProducto.vue?vue&type=style&index=0&id=dcc717b8&lang=scss&scoped=true"

import exportComponent from "/var/www/clients/client1/web6/web/cartamovil-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dcc717b8"]])

export default __exports__